#import "../../../graphql/fragments/engagement-stats-fragment.graphql"

fragment NewsletterEngagementStats on Campaign {
    id
    name
    engagementStats {
        ...EngagementStats
    }
    editions {
        totalCount
        edges {
            node {
                id
                name
                emailTemplate {
                    id
                    subject
                }
                sendTime
                status
                htmlUrlPath
                engagementStats {
                    ...EngagementStats
                }
            }
        }
    }
}
